import React, { Component } from 'react';
import { Card, Avatar } from 'antd';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

const { Meta } = Card;

const StyledAvatar = styled(Avatar)`
  img {
    margin-top: 2px;
  }
`;

class WidgetPage extends Component {
  render() {
    return (
      <div>
        <h1>Pitstop Labs</h1>
        <p style={{ fontSize: 20 }}>
          These widgets are in Beta, we are constantly working to enchance our
          features.
        </p>
        {/* <Card
          hoverable
          // style={{ width: 240 }}
          onClick={() => this.props.history.push('/labs/symptom-analyser')}
          size="small"
        >
          <Meta
            title="Symptom Analyser"
            avatar={
              <Avatar
                size="large"
                shape="square"
                src="data:image/png;base64,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"
              />
            }
          />
          Type in an issue you have with your car and it will tell you where the
          problem is.
        </Card> */}
        <Card
          hoverable
          style={{ marginTop: 20 }}
          onClick={() => this.props.history.push('/labs/repair-pricing')}
          size="small"
        >
          <Meta
            title="Repair Pricing"
            avatar={
              <StyledAvatar
                size="large"
                shape="square"
                src="https://image.shutterstock.com/image-vector/repair-price-vector-icon-style-260nw-389152357.jpg"
              />
            }
          />
          Search for a repair for your car and we will tell you the price for
          it.
        </Card>
        <Card
          hoverable
          style={{ marginTop: 20 }}
          onClick={() => this.props.history.push('/labs/ftconfig')}
          size="small"
        >
          <Meta
            title="Sensitivity Control"
            // avatar={

            //     <Avatar
            //       size="large"
            //       shape="square"
            //       src="https://image.shutterstock.com/image-vector/repair-price-vector-icon-style-260nw-389152357.jpg"
            //     />

            // }
          />
          Change Sensitivity threshold for Messages
        </Card>
      </div>
    );
  }
}

WidgetPage.propTypes = {
  history: PropTypes.object.isRequired,
};

export default withRouter(WidgetPage);
